import axios from '@_system/axios/axios.js'
export default {
	path: '/stockwarning',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	listwarehouse(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listwarehouse', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	getsuppliergoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getsuppliergoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	uploadwln(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/uploadwln', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	hitchhiking(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/hitchhiking', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	custom(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/custom', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	updateitem(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updateitem', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	recompute(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/recompute', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	grouppurchasing(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/grouppurchasing', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/stockwarning.stockwarning', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
